import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "attachment",
  "use": "attachment-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"attachment\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 5.333C2 2.388 4.063 0 7.5 0 10.938 0 13 2.388 13 5.333V11.5s0 .5-.5.5-.5-.5-.5-.5V5.333C12 3.124 10 1 7.5 1S3 3.124 3 5.333V12c0 2 1 3 3 3s3-1 3-3V6c0-.736 0-2-1.5-2S6 5.264 6 6v5.5s0 .5-.5.5-.5-.5-.5-.5V6c0-2 .981-3 2.5-3C9.019 3 10 4 10 6v6c0 2-1 4-4 4s-4-2-4-4V5.333z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol